//  Pagina reportes ( wizard de diferentes tipos de reportes)

import React, { useState } from 'react';
import { useUser } from '../UserContext';
import { Box, Tab, Tabs, Typography } from '@mui/material';
import ReportIncidents from '../components/ReportIncidents';
import ReportIncidentDetails from '../components/ReportIncidentDetails';
import ReportOperations from '../components/ReportOperations';
import ReportClients from '../components/ReportClients';
import ReportQuotations from '../components/ReportQuotations';

export default function Reports() {
  const { hasRole } = useUser();
  const [selectedIncidentReport, setSelectedIncidentReport] = React.useState(null);
  const [tab, setTab] = useState(0);

  return (
    <section>
      {selectedIncidentReport ? (
        <ReportIncidentDetails incidentReport={selectedIncidentReport} onBack={() => setSelectedIncidentReport(null)}
        />
      ) : (
        <>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
            {hasRole(['ADMIN', 'HR_ADMIN']) && (
              <Typography variant="h6">Reportes</Typography>
            )}
            {hasRole(['SUPERVISOR', 'EMPLOYEE']) && (
              <Typography variant="h6">Reportes Incidentes</Typography>
            )}
          </Box>
          <Box>
            {hasRole(['ADMIN', 'HR_ADMIN']) && (
              <Tabs value={tab} onChange={(e, newValue) => setTab(newValue)}>
                <Tab label="Incidentes" />
                <Tab label="Operaciones" />
                <Tab label="Clientes" />
                <Tab label="Cotizaciones" />
              </Tabs>
            )}

            <Box sx={{ mt: 2 }}>
              {tab === 0 &&
                <ReportIncidents onSelectReport={setSelectedIncidentReport} />
              }
              {tab === 1 &&
                <ReportOperations />
              }
              {tab === 2 &&
                <ReportClients />
              }
              {tab === 3 &&
                <ReportQuotations />
              }
            </Box>
          </Box>
        </>
      )}
    </section>
  );
}